/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

function EndOfTenancy_Section3() {
  return (
    <Container>
      <ExtraServices
        description="For properties requiring additional care, we offer extra services at an additional cost:"
        services={[
          "Carpet and upholstery cleaning",
          "Interior appliance cleaning (e.g., fridge, oven)",
          "Window cleaning (interior and exterior)",
          "Wall and ceiling cleaning",
          "Mold and mildew removal",
        ]}
      />
    </Container>
  );
}

export default EndOfTenancy_Section3;
